<span
  #dotContainer
  class="dot-wrapper"
  id="shared-dot-wrapper"
  (click)="onDotsClick($event)"
>
  <div
    class="dot-container"
    [id]="'shared-dot-container-' + ind"
    *ngFor="let dot of createRange(); let ind = index"
  >
    <div class="single-dot" id="shared-single-dot"></div>
  </div>
</span>
